module.exports = __webpack_public_path__ + "img/slide_extensiondegarantia.58b80d35.jpg";